Collection = require 'models/base/collection'

module.exports = class InvoiceCollection extends Collection
  url: '/api/pronto/invoices'